/**
 * Execute the callback when the route changes/updates.
 */
export default function (cb: () => void) {
  const route = useRoute()
  watch(() => route.fullPath, cb)
}
